import { SERVICE_DESK_PROJECT_ANALYTICS } from '@atlassian/jira-common-constants/src/project-types';
import type { SubProduct } from '@atlassian/jira-common-constants/src/sub-product-types';

export const isServiceDesk = (subProduct: SubProduct | null) =>
	subProduct === SERVICE_DESK_PROJECT_ANALYTICS;
